import { render, staticRenderFns } from "./physicalList.vue?vue&type=template&id=7eb9bcf4&scoped=true"
import script from "./physicalList.vue?vue&type=script&lang=js"
export * from "./physicalList.vue?vue&type=script&lang=js"
import style0 from "./physicalList.vue?vue&type=style&index=0&id=7eb9bcf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb9bcf4",
  null
  
)

export default component.exports